import { render, staticRenderFns } from "./StarRating.vue?vue&type=template&id=17170abc&scoped=true"
import script from "./StarRating.vue?vue&type=script&lang=js"
export * from "./StarRating.vue?vue&type=script&lang=js"
import style0 from "./StarRating.vue?vue&type=style&index=0&id=17170abc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17170abc",
  null
  
)

export default component.exports